
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/financial/chart",
      function () {
        return require("private-next-pages/ir/financial/chart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/financial/chart"])
      });
    }
  